import { Button } from "@mui/material";
import useDefaultStyles from "../testStyle/defaultStyle/defaultStyle";

export const QuestionPalette = ({
  subjectNames,
  currentQuestion,
  handleQuestionChange,
  classes,
  currentSubject,
  fetchData = ()=>{}
}) => {
  return (
    <div className={classes.sectionPalette}>
      {subjectNames?.map((subjectName, sectionIndex) => {
        const startIndex = currentSubject[sectionIndex];
        const endIndex = currentSubject[sectionIndex + 1] - 1 || Infinity; // Handle last section
        
        const isActive = currentQuestion >= startIndex && currentQuestion <= endIndex;

        return (
          <Button
            key={sectionIndex}
            onClick={() => {handleQuestionChange(startIndex);fetchData(startIndex)}}
            className={
              isActive ? classes.selectedQuestion : classes.unselectedQuestion
            }
            aria-current={isActive ? "true" : undefined}
          >
            {subjectName}
          </Button>
        );
      })}
    </div>
  );
};